import { Trophy, Gem, Flame, Target, TrendingDown } from "lucide-react";
import { Tooltip, TooltipTrigger, TooltipContent } from "@/components/ui/tooltip";

type AwardIconKey = "trophy" | "gem" | "flame" | "target" | "trendingDown";

const AWARDS: Record<string, { title: string; icon: AwardIconKey }> = {
  LazaroInvestor: { title: "Most Consistent Communicator", icon: "trophy" },
  leevalueroach: { title: "Best Value Investor", icon: "gem" },
  patientinvestor: { title: "On Fire", icon: "flame" },
  sambtrades: { title: "Hit-a-Homerun", icon: "target" },
  RealJimChanos: { title: "Short Shorts", icon: "trendingDown" },
};

interface AwardBadgeProps {
  handle: string;
  position?: "before" | "after";
}

const iconMap: Record<AwardIconKey, { Icon: typeof Trophy; className: string }> = {
  trophy: {
    Icon: Trophy,
    className: "w-4 h-4 text-yellow-500 drop-shadow-[0_0_6px_rgba(234,179,8,0.5)] animate-pulse",
  },
  gem: {
    Icon: Gem,
    className: "w-4 h-4 text-emerald-400 drop-shadow-[0_0_8px_rgba(52,211,153,0.6)] animate-pulse",
  },
  flame: {
    Icon: Flame,
    className: "w-4 h-4 text-orange-500 drop-shadow-[0_0_8px_rgba(249,115,22,0.6)] animate-pulse",
  },
  target: {
    Icon: Target,
    className: "w-4 h-4 text-sky-400 drop-shadow-[0_0_8px_rgba(56,189,248,0.6)] animate-pulse",
  },
  trendingDown: {
    Icon: TrendingDown,
    className: "w-4 h-4 text-red-400 drop-shadow-[0_0_8px_rgba(248,113,113,0.6)] animate-pulse",
  },
};

const AwardBadge = ({ handle }: AwardBadgeProps) => {
  const clean = handle.replace(/^@/, "");
  const award = AWARDS[clean];
  if (!award) return null;

  const { Icon, className } = iconMap[award.icon];

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span className="inline-flex cursor-pointer">
          <Icon
            className={className}
            style={{ animationDuration: "3s" }}
          />
        </span>
      </TooltipTrigger>
      <TooltipContent side="top" className="flex items-center gap-2 px-3 py-2">
        <Icon className={className.replace("animate-pulse", "")} />
        <span className="text-sm font-semibold">{award.title}</span>
      </TooltipContent>
    </Tooltip>
  );
};

export default AwardBadge;
